'use client'

import Heading from '@/components/Heading/Heading'
import ContextualHelpModal from '@/components/Help/ContextualHelpModal'
import { useCallback, useState } from 'react'
import CategoriesPage from '../categories/CategoriesPage'
import FontManagerPage from '@/components/FontManager/Components/FontManagerPage'
import DesignTemplatePage from '@/components/DesignTemplate/DesignTemplatePage'

const tabs = [
  {
    name: 'Graphic Categories',
  },
  {
    name: 'Fonts',
  },
  {
    name: 'Design Templates',
  },
]

export default function Home() {
  const [selectedTab, setSelectedTab] = useState(0)
  const [isHelpOpen, setIsHelpOpen] = useState(false)

  const handleOnSelectedTabChange = (tabIndex: number) => {
    setSelectedTab(tabIndex)
  }

  const getCurrentTabContent = useCallback(() => {
    switch (selectedTab) {
      case 0:
        return <CategoriesPage hideHeader />
      case 1:
        return <FontManagerPage hideHeader />
      case 2:
        return <DesignTemplatePage hideHeader />
      default:
        return <CategoriesPage hideHeader />
    }
  }, [selectedTab])

  return (
    <div className="flex w-full bg-white gap-md min-h-full">
      <div className="flex-grow flex flex-col">
        <Heading
          title={'Media'}
          description={'Manage graphic categories, fonts, and design templates.'}
          help={{
            title: 'Help',
            onClick: () => setIsHelpOpen(true),
          }}
          tab={{
            onSelectedChange: handleOnSelectedTabChange,
            selectedTab: selectedTab,
            tabs: tabs,
          }}
        />
        <div className={'pr-xxl flex flex-col flex-grow'}>{getCurrentTabContent()}</div>
      </div>
      <ContextualHelpModal categoryId="media" isOpen={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
    </div>
  )
}
